import React from "react";
import { NavLink } from "react-router-dom";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

export default function EmployeeLayout({ title, description, children }) {
  const user = getStoredUser();
  const navItems = [
    ...(user?.can_view_dashboard === false ? [] : [{ to: "/dashboards", label: "Dashboard", icon: "D" }]),
    { to: "/employee-lead-report", label: "Assigned Resumes", icon: "R" },
    { to: "/follow-up", label: "Follow-ups", icon: "F" },
    ...(user?.can_view_resume_library ? [{ to: "/employee/resume-library", label: "Resume Library", icon: "L" }] : []),
    ...(user?.can_manage_sub_companies ? [{ to: "/employee/sub-companies", label: "Sub Companies", icon: "C" }] : []),
    ...(user?.can_upload_resumes === false ? [] : [{ to: "/employee/upload-resumes", label: "Upload Resumes", icon: "U" }]),
    ...(user?.can_post_jobs ? [{ to: "/employee/jobs", label: "Post Job", icon: "+" }] : []),
  ];
  const dashboardPath = navItems[0]?.to || "/employee-lead-report";

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-slate-50">
      <div className="sticky top-16 z-30 border-b border-gray-200 bg-white">
        <div className="flex items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="text-xl text-blue-600">+</span>
            <div className="flex items-center gap-3">
              <h1 className="text-lg font-semibold text-gray-900">Recruiter Panel</h1>
              <span className="rounded bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-600">v1.0</span>
            </div>
          </div>
          <NavLink
            to={dashboardPath}
            className="rounded-md bg-gray-50 px-3 py-1.5 text-xs text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
          >
            Back to Dashboard
          </NavLink>
        </div>
      </div>

      <div className="border-b border-gray-200 bg-white">
        <div className="overflow-x-auto px-4 sm:px-6">
          <div className="flex gap-6">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`
                }
              >
                <span>{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div className="px-4 py-8">
        <div className="w-full">
          <div className="mb-4 rounded-lg border border-gray-200 bg-white px-4 py-4 shadow-sm">
            <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
            {description ? <p className="mt-2 text-sm text-slate-600">{description}</p> : null}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
